var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jc-container-chart"},[_c('jcb-monitor-chart',{ref:"monitorChart",attrs:{"params":_vm.monitorParams,"enable-full-chart":_vm.enableFullChart,"update-options":_vm.updateOptions,"enableSwitchAggregates":_vm.enableFullChart},on:{"error":_vm.onError}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f8ab93b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PerformanceMonitor/SingleMonitorChart.vue
// module id = null
// module chunks = 